import { render } from "./ChooseStudentByUcoModalForm.vue?vue&type=template&id=2051dc70"
import script from "./ChooseStudentByUcoModalForm.vue?vue&type=script&lang=js"
export * from "./ChooseStudentByUcoModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__